import useLocales from "@hooks/useLocales";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { useBanner } from "src/contexts/BannerContext";

export function VersionNotifier() {
  const { translate } = useLocales();
  const { hasNewVersion } = useBanner();
  return (
    <Dialog
      fullWidth={true}
      open={hasNewVersion}
      disableEscapeKeyDown
      onClose={(event, reason) => {
        // Prevent closing via backdrop click
        if (reason === "backdropClick") return;
      }}
    >
      <DialogTitle
        sx={{
          paddingBottom: "0 !important",
          paddingTop: "4px !important",
          fontWeight: 700,
          fontSize: "16px",
        }}
      >
        {translate("update_available")}
        <span style={{ fontSize: 20, marginLeft: 8 }}>🚀</span>
      </DialogTitle>

      <DialogContent
        sx={{
          padding: "0 24px 4px 24px !important",
        }}
      >
        {translate("new_app_verion_available")}
      </DialogContent>

      <DialogActions
        sx={{
          ".MuiDialog-paper &": {
            padding: "0 24px 8px 24px !important",
          },
        }}
      >
        <Button
          variant="contained"
          size="medium"
          sx={{
            textTransform: "capitalize",
            backgroundColor: "#0b427a !important",
          }}
          onClick={() => window.location.reload()}
        >
          {translate("refresh")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
